<template>
  <div class="liquidationLoss-detail">
    <el-card class="box-card">
      <h4>基础信息</h4>
      <div class="base-info">
        <ul class="info-list">
          <li>盘点损益单编号：{{ lossDetailList.baseInfo.yilCode || '' }}</li>
          <li>生成时间：{{ lossDetailList.baseInfo.yilTime || '' }}</li>
          <li>状态：{{ handState(lossDetailList.baseInfo.yilHandState,'部分') }}</li>
          <li>盘点单编号：{{ lossDetailList.baseInfo.yitCode || '' }}</li>
        </ul>
      </div>
      <warehouse-select v-show="false" ref="warehouseSelect"></warehouse-select>
    </el-card>
    <el-card class="box-card">
      <h4>损益商品信息</h4><br>
      <div class="goods-info">
        <!-- 列表 S -->
        <page-table :refresh="refresh"
                    permission="liquidationLoss"
                    :list="lossDetailList.goodsList"
                    :fieldList="fieldList"
                    :btns="['handle']"
                    :handleSlot='true'
                    handelWidth='150'>
          <template v-slot:col-yidHandleState="scope">
            {{ handState(scope.row.yidHandleState,'') }}
          </template>
          <template v-slot:col-yidHandleResult="scope">
            <span v-if="scope.row.yidHandleResult == 1">保持原系统库存</span>
            <span v-if="scope.row.yidHandleResult == 2">以差异值调整库存</span>
          </template>
          <template v-slot:col-yidSysUse="scope">
            <span>{{ scope.row.yidSysUse || 0 }}{{scope.row.minUnitName}}</span>
            <div class="goods-tips">
              {{ getBoxAndPiece(scope.row,scope.row.yidSysUse) }}
            </div>
          </template>
          <template v-slot:col-yidInventoryUse="scope">
            <span>{{ scope.row.yidInventoryUse || 0 }}{{scope.row.minUnitName}}</span>
            <div class="goods-tips">
              {{ getBoxAndPiece(scope.row,scope.row.yidInventoryUse) }}
            </div>
          </template>
          <template v-slot:col-yidUseDiff="scope">
            <span :class="redOrGreen(scope.row.yidUseDiff)">{{ scope.row.yidUseDiff || 0 }}{{scope.row.minUnitName}}</span>
            <div class="goods-tips">
              {{ getBoxAndPiece(scope.row,scope.row.yidUseDiff) }}
            </div>
          </template>
          <template v-slot:col-yidSysUn="scope">
            <span>{{ scope.row.yidSysUn || 0 }}{{scope.row.minUnitName}}</span>
            <div class="goods-tips">
              {{ getBoxAndPiece(scope.row,scope.row.yidSysUn) }}
            </div>
          </template>
          <template v-slot:col-yidInventoryUn="scope">
            <span>{{ scope.row.yidInventoryUn || 0 }}{{scope.row.minUnitName}}</span>
            <div class="goods-tips">
              {{ getBoxAndPiece(scope.row,scope.row.yidInventoryUn) }}
            </div>
          </template>
          <template v-slot:col-yidUnDiff="scope">
            <span :class="redOrGreen(scope.row.yidUnDiff)">{{ scope.row.yidUnDiff || 0 }}{{scope.row.minUnitName}}</span>
            <div class="goods-tips">
              {{ getBoxAndPiece(scope.row,scope.row.yidUnDiff) }}
            </div>
          </template>
          <template v-slot:col-yidProductionTime="scope">
            <span v-if="scope.row.yidFinishOpenStatus == 0">-</span>
            <span v-else>{{scope.row.yidProductionTime || '无'}}</span>
          </template>
          <template v-slot:handleSlot="scope">
            <div class="handle-btn" v-if="scope.row.yidHandleState == 0">
              <el-button type="text" :disabled="$has('liquidationLossEdit')" @click="edit(scope.row, 1)">保持原系统库存</el-button>
              <el-button type="text" :disabled="$has('liquidationLossEdit')" @click="edit(scope.row, 2)">以差异值调整库存</el-button>
            </div>
            </template>
        </page-table>
        <!-- 列表 E -->
        <div class="detail-tips">备注：列表中的“系统库存”为盘点时的系统库存，非商品实时库存。库存差异=盘点数量-系统库存。</div>
      </div>
    </el-card>
  </div>
</template>

<script>
import pageTable from '@/components/Table/Index'
import liquidationManage from '@/store/liquidationManage/index.js'
import { GETINVENTORYLOSSDETAIL, INVENTORYHANDLE } from '@/store/liquidationManage/types.js'
import WarehouseSelect from '@/components/WarehouseSelect.vue'
export default {
  components: {
    pageTable,
    WarehouseSelect
  },
  data () {
    return {
      size: 10,
      page: 1,
      yilCode: this.$route.params.code,
      WarehouseCode: '',
      isMdOpen: null
    }
  },
  computed: {
    // 列表
    lossDetailList () {
      return liquidationManage.state.lossDetailList
    },
    // 状态
    liquidationLossMark () {
      return liquidationManage.state.liquidationLossMark
    },
    fieldList () {
      let list = [
        { label: '商品名称', prop: 'goodsName', align: 'center' },
        { label: '状态', prop: 'yidHandleState', align: 'center', type: 'slot' },
        { label: '处理结果', prop: 'yidHandleResult', align: 'center', type: 'slot' }
      ]
      let normal = [
        { label: '系统库存\n（正常品）', prop: 'yidSysUse', type: 'slot', width: '130px', align: 'center' },
        { label: '盘点数量\n（正常品）', prop: 'yidInventoryUse', type: 'slot', width: '130px', align: 'center' },
        { label: '库存差异\n（正常品）', prop: 'yidUseDiff', type: 'slot', width: '130px', align: 'center' }
      ]
      let damage = [
        { label: '系统库存\n（破损品）', prop: 'yidSysUn', type: 'slot', width: '130px', align: 'center' },
        { label: '盘点数量\n（破损品）', prop: 'yidInventoryUn', type: 'slot', width: '130px', align: 'center' },
        { label: '库存差异\n（破损品）', prop: 'yidUnDiff', type: 'slot', width: '130px', align: 'center' },
        { label: '供应商', prop: 'supplierName', align: 'center', labelWidth: '70px' }
      ]
      if (this.isMdOpen) {
        list.splice(1, 0, { label: '生产日期', prop: 'yidProductionTime', align: 'center', type: 'slot' })
      }
      // 按货位、商品货位
      if (this.isYitTypeByTotal) {
        let arr = [
          { label: '库区', prop: 'yaName', align: 'center' },
          { label: '货位编码', prop: 'ylCode', align: 'center' }
        ]
        list.splice(0, 0, ...arr)
      }
      list = [...list, ...normal, ...damage]
      return list
    },
    // 盘点类型（0按商品货位、1按商品总数、2按货位）
    isYitTypeByTotal () {
      let { yitType } = this.lossDetailList.baseInfo
      // 商品总数
      if (yitType === 1) {
        return false
      }
      // 货位、商品货位
      return true
    }
  },
  watch: {
    liquidationLossMark: {
      deep: true,
      handler (val) {
        if (val === 1) {
          liquidationManage.state.liquidationLossMark = 0
          this.getList()
        }
      }
    }
  },
  mounted () {
    this.getList()
    this.warehouseCode = this.$route.params.warehouseCode
    console.log(this.$route.params)
    // setTimeout(() => {
    if (this.$refs.warehouseSelect.isMdOpen(this.$route.params.warehouseCode)) {
      this.isMdOpen = true
    }
    // }, 1000)
  },
  methods: {
    // 分页刷新
    refresh (page, size) {
      this.page = page
      this.size = size
      this.getList()
    },
    // 请求数据列表
    getList () {
      let params = {
        yilCode: this.yilCode
      }
      this.$store.dispatch(GETINVENTORYLOSSDETAIL, params)
    },
    // 编辑
    edit ({ yidId }, yidHandleResult) {
      let tips = '保持原系统库存，指保持原系统上的库存数据，不做修改，您确定执行？'
      if (yidHandleResult === 2) tips = '以差异值调整库存，指对当前实时库存做差异调整(加或减)，执行后不可修改，您确定执行？'

      this.$confirm(tips, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          yidId,
          yidHandleResult,
          yilCode: this.yilCode
        }
        this.$store.dispatch(INVENTORYHANDLE, params)
      })
    },
    // 计算箱和件
    getBoxAndPiece (row, number) {
      return `(${number ? parseInt(number / row.box) : '0'}${row.maxUnitName}${number ? number % row.box : '0'}${row.minUnitName})`
    },
    // 库存差异 文字颜色
    redOrGreen (val) {
      if (!val || val === 0) return ''
      if (val > 0) return 'status-close'
      return 'status-open'
    },
    handState (val, str) {
      let status = ''
      switch (val) {
        case 0:
          status = '待处理'
          break
        case 1:
          status = str + '已处理'
          break
        case 2:
          status = '已完成'
          break
      }
      return status
    }
  }
}
</script>

<style scoped>
.liquidationLoss-detail .page-tabel >>> .el-card__body .handle-box {
  margin-bottom: 0;
}
.box-card {
  margin-bottom: 8px;
}
h4 {
  font-weight: 400;
  font-size: 20px;
}
.base-info .info-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: 40px;
}
.base-info .info-list li {
  line-height: 60px;
  margin-right: 70px;
}
.goods-tips {
  color: #999;
  white-space: initial;
}
.detail-tips {
  color: #999;
  font-size: 14px;
  margin-top: 10px;
  margin-left: 10px;
}
.liquidationLoss-detail >>> .el-table .cell{
  white-space:pre-line;
}
.handle-btn {
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/page/liquidationManage/LiquidationLossDetail.vue